module.exports = __webpack_public_path__ + "img/p5.e4f4aad2.png";